import { PlannerBase }   from "../planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
import {
  PLANNER_SCROLL_SET_GETTERS,
  PLANNER_SCROLL_UPDATED,
  PLANNER_SCROLL_CHANGE_NATIVES,
  PLANNER_SCROLL_TAB_POSITION,
  PLANNER_SCROLL_SCROLL
} from 'apps/events';
import { MouseDragUtil, IMouseDragUtilOptions } from 'utilities/mouse/drag_util';
import {
  ScrollModel
} from './model';
class Scroll extends PlannerBase {
  tab: HTMLElement;
  tabStartX: number;
  dragUtil: MouseDragUtil;
  dragUtilOptions: IMouseDragUtilOptions;
  init(){
    super.init()
    this.watch();
    this.listenMount([this.onMountScroll]);
    document.addEventListener(PLANNER_SCROLL_UPDATED, (e) => this.onUpdateScroll(e));
    document.addEventListener(PLANNER_SCROLL_CHANGE_NATIVES, (e) => this.onUpdateScroll(e));
    document.addEventListener(PLANNER_SCROLL_TAB_POSITION, (e) => this.setTabPosition(e));
  }
  onMountScroll(){
    this.tab = this.querySelector('.tab') as HTMLElement;
    setTimeout(() => {
      let detail = { getScrollWidth: () => { return this.getScrollWidth() } }
      let customEvent = new CustomEvent(PLANNER_SCROLL_SET_GETTERS, {detail: detail});
      document.dispatchEvent(customEvent);
    }, 1);
  }
  getScrollWidth(): number{
    return this.rootElement().clientWidth;
  }
  onUpdateScroll(e){
    let scrollModel: ScrollModel = e.detail;
    this.tab.style.width = scrollModel.tabWidth + 'px';
  }
  onDown(mouseEvent){
    this.tabStartX = this.tab.clientLeft;
    this.dragUtilOptions = {
      onDrag: () => { this.onDragging() },
      onEnd: () => { this.onEndDrag() },
      unitX: 1,
      unitY: 0
    };
    this.dragUtil = new MouseDragUtil(mouseEvent, this.dragUtilOptions);
  }
  onDragging(){
    let stepX = this.dragUtil.pos().stepX;
    let newLeft = this.tabStartX + stepX;
    let customEvent = new CustomEvent(PLANNER_SCROLL_SCROLL, { detail: newLeft });
    document.dispatchEvent(customEvent);
  }
  onEndDrag(){
    this.dragUtil = undefined;
  }
  setTabPosition(e){
    let scrollModel: ScrollModel = e.detail;
    this.tab.style.left = scrollModel.scrollPosition + 'px';
  }
}
riot.mixin('orders.planner.scroll', Scroll as riot.TagMixin)
